export const getEmailTemplatesDisplayPayload = emailTemplates => {
  return emailTemplates?.map((item, index) => ({
    enabled: item.is_enabled,
    id: item.id,
    position: index,
  }))
}
